<script>
	import NumberBoxInput from '../components/NumberBoxInput.svelte';
	import standardizeDate from "../helpers/standardizeDate.js";
	import { beforeUpdate } from 'svelte';
	import fetchNode from '../helpers/FetchNode';
	import FileDownload from 'js-file-download';

	export let page;
	export let limit;
	export let count;
	export let currentView;
	export let dateRange;
	export let user;

	const pageSizes = [10,25,50,100,200];

	$: lastRecord = Math.min(limit * page, count);
	$: firstRecord = (page-1) * limit + 1;

	function toggleView() {
    currentView = currentView == 0 ? 1 : 0;
  }

	async function generateReport( user, dateRange ){
		try{
			const startDate = standardizeDate(dateRange.start);
			const endDate = standardizeDate(dateRange.end);
			let response = await fetchNode('generateExcel',{
				user: user.airbetterRoleId ? "staff" : user.accountRole,
				start: startDate,
				end: endDate
			},false);
			FileDownload(response,'file.xlsx')
		}catch(error){
			console.log(error);
			console.error("An error ocurred exporting file");
		}
	}

	function generatePdf(){
		var dateStart = standardizeDate(dateRange.start);
		var dateEnd = standardizeDate(dateRange.end);
		var tableDiv = document.getElementById("table").innerHTML;
		var mywindow = window.open('', '', 'height=400,width=600');
		mywindow.document.write('<head><title>List View Table '+dateStart+' to '+dateEnd+'</title><link rel="stylesheet" type="text/css" href="/pdfListView.css"></head>');
		mywindow.document.write('<html><body >');
		mywindow.document.write(tableDiv);
		mywindow.document.write('<script type="text/javascript">addEventListener("load", () => { print();close(); })<\/script>');
		mywindow.document.write('</body></html>');

		mywindow.document.close(); // necessary for IE >= 10
		mywindow.focus(); // necessary for IE >= 10*/


		return true;
	}
</script>

<div class="{currentView === 0 ? 'card pagination-controls' : 'card pagination-controls align-right'}">
	{#if currentView !== 1}
		{#if count > 0}
			<p class='summary'>Showing {firstRecord} - {lastRecord} of {count} properties</p>
		{:else}
			<p class='summary'>No Properties found</p>
		{/if}
        {#if user.accountRole != "cleaner"}

		<button class="toggle-view" on:click={toggleView}>
				View Table
		</button>
		{/if}
		<p class='page-controls'>
			<span>page</span>
			<NumberBoxInput bind:value='{page}' min='1' max='{Math.ceil(count/limit)}' />
			<span> of {Math.ceil(count/limit)}</span>
		</p>
		<p class='limit-controls'>
			<span>Show</span>
			{#each pageSizes as size}
				<button class:selected='{size === limit}' on:click|preventDefault={() => limit = size}  >{size}</button>
			{/each}
		</p>
	{/if}
	{#if currentView === 1}
	<div class="list-view-container">
		<button class="toggle-view" on:click={toggleView}>
			View Calendar
		</button>
		<div class="export-container" on:click={generateReport(user,dateRange)}>
			Export as Excel
			<img src="/img/exportToExcel.png" class="export-excel" alt="Export to excel"/>
		</div>
		<div class="export-container" on:click={generatePdf}>
			Export as PDF
			<img src="/img/exportToExcel.png" class="export-excel" alt="Export to pdf"/>
		</div>
	</div>
	{/if}
</div>

<style>
.pagination-controls{
	display: flex;
	border-bottom: none;
	padding: 5px 30px;
	line-height: 32px;
}
.summary{
	flex-grow: 1;
}
.page-controls{
	display: flex;
	margin-right:20px;
}
.page-controls span{
	margin: 0 5px;
}
.limit-controls button{
	margin-left:1px;
}
.limit-controls button.selected{
	background-color: #FFF5F6;
}
.toggle-view{
	padding: 0 1rem;
	background-color: #EF4064;
	color: white;
	font-weight: 600;
	border-radius: 5px;
	margin: 12px 30px 12px 0;
}
.export-container{
	display: flex;
	align-items: center;
	margin: 12px 30px 12px 0;
	border-radius: 5px;
	background-color: #EF4064;
	cursor: pointer;
	color: white;
	font-weight: 600;
	padding: 0 8px 0 12px;
}
.export-excel{
	width: 30px;
	height: 30px;
	padding: 5px 4px 5px 10px;
}
.list-view-container{
	display: flex;
}
.align-right{
	justify-content: flex-end;
}
@media (max-width:560px) {
 .pagination-controls{
 	flex-direction: column;
 }
}

</style>
